import { FormLabel, styled } from '@mui/material';

export const Label = styled(FormLabel)`
  font-size: 0.875rem;
  color: ${(props) => props.theme.palette.text.primary};
  margin-bottom: ${(props) => props.theme.spacing(0.5)};
`;
